import { AdminReviews } from "@/components/admin/AdminReviews";
import { AdminRebook } from "@/components/admin/AdminRebook";
import { AdminQuoteTemplate } from "@/components/admin/AdminQuoteTemplate";
import { GoLiveChecklist } from "@/components/admin/GoLiveChecklist";
import { AdminSchedule } from "@/components/admin/AdminSchedule";
import { StripeStatusCard } from "@/components/admin/StripeStatusCard";
import { AdminDocuments } from "@/components/admin/AdminDocuments";
import { AdminAgreements } from "@/components/admin/AdminAgreements";

export function AdminSettings() {
  return (
    <div className="space-y-6" data-testid="admin-settings">
      <AdminSchedule />
      <StripeStatusCard />
      <AdminDocuments />
      <AdminAgreements />
      <GoLiveChecklist />
      <AdminReviews />
      <AdminRebook />
      <AdminQuoteTemplate />
    </div>
  );
}
